import ActiveRecord from './active_record/base'

class EventSeries extends ActiveRecord {
	static tableName = 'eventSeries'
}

export default EventSeries
